import { render, staticRenderFns } from "./NavigationFooter.vue?vue&type=template&id=9c5ac500&scoped=true&"
import script from "./NavigationFooter.vue?vue&type=script&lang=js&"
export * from "./NavigationFooter.vue?vue&type=script&lang=js&"
import style0 from "./NavigationFooter.vue?vue&type=style&index=0&id=9c5ac500&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5ac500",
  null
  
)

export default component.exports